import { Button, ButtonProps } from '@chakra-ui/react';
import IconSave from 'assets/icons/icon-save.svg?react';

export default function SaveButton(props: ButtonProps) {
  return (
    <Button
      variant="primary"
      bgColor="black"
      type="button"
      ml="auto"
      rightIcon={<IconSave />}
      {...props}
    />
  )
}
